import { getProductImage } from '@/assets/js/utils';

/**
 * 商品图片处理 Hook（保持向后兼容）
 * 处理商品主图和悬浮图的显示逻辑，支持灰底图优先级和混色模式控制
 * @param {Object} props - 组件的 props 对象
 * @param {string} image_key - 图片键名，默认为 'origin_image'
 */
export function useProductImage(props, image_key = 'origin_image') {
  // 使用静态方法，并用 computed 包装以保持响应式
  const mainImage = computed(() => {
    return getProductImage({
      product: props.product,
      showMaterialImg: props.showMaterialImg,
      image_key,
    }).mainImage;
  });

  const hoverImage = computed(() => {
    return getProductImage({
      product: props.product,
      showMaterialImg: props.showMaterialImg,
      image_key,
    }).hoverImage;
  });

  const hasGrayImage = computed(() => {
    return getProductImage({
      product: props.product,
      showMaterialImg: props.showMaterialImg,
      image_key,
    }).hasGrayImage;
  });

  return {
    mainImage,
    hoverImage,
    hasGrayImage,
  };
}
